import { render, staticRenderFns } from "./DatasetDetails.vue?vue&type=template&id=15243596&scoped=true"
import script from "./DatasetDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DatasetDetails.vue?vue&type=style&index=0&id=15243596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15243596",
  null
  
)

export default component.exports